import { MatchDetailsStylesSchema } from './NewMatchDetailsPage.styles';

export const matchDetailsStyles: MatchDetailsStylesSchema = {
  headerFlex: {
    flexDir: 'row',
    justify: 'space-between',
  },
  headerHeading: {
    alignItems: 'center',
    display: 'flex',
    flexDir: 'row',
    fontSize: 'md',
    fontWeight: 'medium',
  },
  headerIconButton: {
    color: 'alpha.600',
    p: '1',
    size: 'xs',
    variant: 'link',
    _hover: {
      opacity: '.8',
    },
  },
  headerSkeletonText: {
    sx: {
      '.state-prior': { color: 'white' },
    },
  },
  headerVsBox: {
    color: 'alpha.700',
  },
  bodyStack: {
    color: 'white',
    mt: ['-1', null, '0', '-2'],
    p: '2',
    minH: '90vh',
  },
  bodyInnerWrapper: {
    alignItems: 'center',
    display: [null, null, null, 'flex'],
    justifyContent: 'space-between',
  },
  sgmLogo: {
    color: 'alpha.500',
    h: '1.25em',
    ml: '1',
    w: 'auto',
  },

  scrollButtonGroup: {
    variant: 'filter',
    boxShadow: 'none',
    bg: 'none',
    maxH: '9',
    pos: 'relative',
  },
  toMarketButton: {
    border: '2px solid',
    borderColor: 'alpha.100',
    _active: {
      bg: 'alpha.100',
      fontWeight: 'bold',
      color: 'alpha.700',
    },
    _last: { mr: 2 },
  },
  loadingSkeletonText: {
    my: '4',
    spacing: '4',
    skeletonHeight: '2',
  },
  accordion: {
    display: 'flex',
    flexDir: ['column', null, null, 'row'],
    mx: '-1',
  },
  accordionStack: {
    px: '1',
    w: { lg: '50%' },
    _notFirst: {
      mt: ['2', null, null, '0'],
    },
  },
  accordionItem: {
    bg: 'white',
    border: '0',
    borderRadius: 'base',
    boxShadow:
      '0 3px 5px rgba(0, 0, 0, .2), 0 1px rgba(255, 255, 255, .15) inset',
    overflow: 'hidden',
  },
  accordionButton: {
    bgGradient: 'linear(to-b, alpha.300, alpha.700)',
    boxShadow: '0px -2px 0px 0px rgba(0, 0, 0, 0.15) inset',
    color: 'white',
    fontSize: 'xs',
    fontWeight: 'bold',
    p: '2',
    pos: 'relative',
    textAlign: 'left',
    _after: {
      borderBottomWidth: '1px',
      borderColor: 'blackAlpha.400',
      bottom: '0',
      boxShadow: '0 1px rgba(255, 255, 255, .07)',
      content: '""',
      left: '0',
      opacity: '0',
      pos: 'absolute',
      right: '0',
      transition: 'inherit',
      zIndex: '1',
    },
    _expanded: {
      _after: { opacity: '1' },
    },
    _hover: {
      bgGradient: 'linear(to-b, alpha.700, alpha.700)',
    },
  },

  marketLayoutIconFlex: {
    align: 'center',
    flex: '1',
    gap: '1',
  },
  marketLayoutTooltip: {
    fontSize: 'xs',
  },
  marketLayoutIcon: {
    color: 'white',
    fontSize: 'lg',
  },
  marketLoadingCenter: {
    boxSize: '6',
  },
  centerLoadingSpinner: {
    color: 'white',
    size: 2,
  },
  marketLayoutLoadedIcon: {
    color: 'white',
    fontSize: '2xl',
  },
  marketLayoutAccordionPanel: {
    p: '0',
  },
  cancelButton: {
    fontFamily: 'roboto',
    fontSize: 'xs',
    px: '3',
  },
  clearButton: {
    fontFamily: 'roboto',
    fontSize: 'xs',
    ml: '3',
    px: '3',
  },
  countdown: {
    sx: {
      textTransform: 'uppercase',
      '&&&.state-prior': {
        p: 0,
        lineHeight: 'initial',
      },
    },
  },
  sgmLogoV2: {
    color: 'white',
    w: '8',
    h: 'auto',
  },
  wrapperScrollSgm: { w: '100%', maxW: '100%', gap: '2', mt: '2' },
  scrollButtonGroupV2: {
    variant: 'unstyled',
    flex: 1,
    position: 'relative',
    minH: '34px',
    bg: 'none',
    boxShadow: 'none',
  },
  accordionItemActive: {
    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)',
  },
  toMarketButtonV2: {
    color: 'white',
    fontSize: 'xs',
    textTransform: 'uppercase',
    minW: 'fit-content',
    fontWeight: 'bold',
    cursor: 'pointer',
    border: 'none',
    bg: 'none',

    sx: {
      '&&': {
        px: 2,
        ml: 0,
      },

      '&[data-active], _active': {
        color: 'gamma.200',
        bg: 'none',
        border: 'none',
      },

      '.chakra-button__icon': {
        margin: 0,
      },
    },

    _last: { mr: 2 },
  },
  sgmBtn: {
    bg: 'beta.500',
    borderColor: 'beta.900',
    borderStyle: 'solid',
    borderWidth: '2px',
    boxShadow:
      '0px 4px 10px 0px rgba(0, 0, 0, 0.25), 0px 1px 0px 0px rgba(255, 255, 255, 0.50) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.30) inset',
    color: 'alpha.500',
    px: '2',
    sx: {
      svg: {
        color: 'white',
        fill: 'white',
      },
    },
  },
  sgmBtnActive: {
    sx: {
      svg: {
        color: 'alpha.500',
        fill: 'alpha.500',
        textShadow: '0px 2px 4px rgba(0, 0, 0, 0.20)',
      },

      '&&': {
        border: 'none',
        px: '1',
        bg: 'beta.800',
        boxShadow: '0px 4px 5px 0px rgba(0, 0, 0, 0.35) inset',
        borderColor: 'transparent',
      },
    },

    _after: { display: 'none' },
  },
};
